import { Tron } from './Tron'

export { TronChainId, TronRes } from './constants'
export { tronErrors } from './tronError'

export const tron = new Tron()
